module.exports = __webpack_public_path__ + "static/media/shape_images.7e08a024.jpg";